import { apiClient } from '@/config/api';
import { ProjectAccount, ProjectAccountType } from '@/types';

export interface CreateProjectAccountData {
  login: string;
  password: string;
  type: string; // IRI
  project: string; // IRI
}

export interface UpdateProjectAccountData {
  login?: string;
  password?: string;
  type?: string; // IRI
  project?: string; // IRI
}

export const projectAccountService = {
  async getProjectAccounts(projectId?: number): Promise<ProjectAccount[]> {
    const params: Record<string, unknown> = {
      'groups[]': ['projectAccount:read'],
    };
    if (projectId) {
      params.project = `/api/projects/${projectId}`;
    }
    const response = await apiClient.get('/project_accounts', { params });
    // API Platform can return either 'hydra:member' or 'member'
    const data = response.data;
    return data['hydra:member'] || data['member'] || [];
  },

  async getProjectAccount(id: number): Promise<ProjectAccount> {
    const response = await apiClient.get(`/project_accounts/${id}`);
    return response.data;
  },

  async createProjectAccount(data: CreateProjectAccountData): Promise<ProjectAccount> {
    const response = await apiClient.post('/project_accounts', data);
    return response.data;
  },

  async updateProjectAccount(id: number, data: UpdateProjectAccountData): Promise<ProjectAccount> {
    const response = await apiClient.put(`/project_accounts/${id}`, data);
    return response.data;
  },

  async deleteProjectAccount(id: number): Promise<void> {
    await apiClient.delete(`/project_accounts/${id}`);
  },

  async getProjectAccountTypes(): Promise<ProjectAccountType[]> {
    const response = await apiClient.get('/project_account_types');
    const data = response.data;
    return data['hydra:member'] || data['member'] || [];
  },
};
